<template>
  <div class="content-game-loading">
    <div class="m-auto text-center">
      <Spinner label="Loading..." class="m-auto spinner-main"></Spinner>
      <br />
       loading
    </div>
  </div>
</template>

<script>
export default {
  async mounted() {
    try {
      let redirect_Page = () => {
        const params = new URLSearchParams(window.location.search);
        let redirectPath = params.get("redirect");
        
        if (window.location.pathname == "/") {
          if (redirectPath) {
            let path = redirectPath == "/" ? "/login" : redirectPath;
            return this.$router.replace(path);
            // }
          } else {
            let path =
              window.location.pathname == "/"
                ? "/login"
                : window.location.pathname;

            return this.$router.replace(path + window.location.search);
          }
        }
      };
      if (process.env.NODE_ENV != "development") this.liffOpen();
      redirect_Page();
    } catch (error) {
      alert(error + "alert");
      console.error(error);
    }
  },
  methods: {
    async liffOpen() {
      let isInLine = await this.$liff.isInClient();
      let isMobileDevice = window.matchMedia("(any-pointer: coarse)").matches;
      let getOs = await this.$liff.getOS();
      if (
        !isInLine &&
        isMobileDevice &&
        (getOs == "web" || getOs == "ios" || getOs == "android")
      ) {
        setTimeout(() => {
          if (this.$route.path) {
            window.location.href = `line://app/${this.$liffId}?redirect=${window.location.pathname}${window.location.search}`;
          } else {
            window.location.href = `line://app/${this.$liffId}/${window.location.pathname}${window.location.search}`;
          }
        }, 1000);
      }
    }
  }
};
</script>

<style>
.content-game-loading {
  height: 100vh;
  top: 0;
  width: 100%;
  z-index: 1;
  display: flex;
}
</style>
